<div *ngIf="service.show" class="viewer-container">
    <div class="viewer-content">
        <img class="main-img" [ngSrc]="service.src" fill/>
        <button type="button" class="btn btn-icon close-viewer btn-primary" aria-label="home"
            (click)="service.show = false">
            <cds-icon shape="times"></cds-icon>
        </button>
    </div>
    <div class="modal-backdrop"></div>
</div>
